<div class="mask" *ngIf="isVisible | async">
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  <div class="mask__overlay"></div>
</div>